var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktop = function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4v2h3v1H6v-1h3v-2H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14Zm-5 12h-4v2h4v-2Zm5-1V6H5v10h14Z",
    fill: "#000624"
  })));
};
export default SvgDesktop;